import { render } from "./FixedCalendar.vue?vue&type=template&id=05c880f9&scoped=true"
import script from "./FixedCalendar.vue?vue&type=script&lang=js"
export * from "./FixedCalendar.vue?vue&type=script&lang=js"

import "./FixedCalendar.vue?vue&type=style&index=0&id=05c880f9&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\PC\\Documents\\RWI\\surefooted-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c880f9"]])

export default __exports__